import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <section className="services-section" id="services">
      <h1 className="main-heading">Our Partner Companies & Services</h1>

      {/* Companies */}
      <div className="companies-container">
        <div className="company-card">
          <h2 className="company-name">Cait Pvt Ltd</h2>
          <p className="company-location">Pune, Maharashtra</p>
          <p className="company-desc">
            Leading provider of smart infrastructure and digital services in Pune.
          </p>
        </div>
        <div className="company-card">
          <h2 className="company-name">Jm-tech Solutions Ahmedabad</h2>
          <p className="company-location">Ahmedabad, Gujarat</p>
          <p className="company-desc">
            Delivering impactful IT and software solutions across India.
          </p>
        </div>
      </div>

      {/* Tie-ups and Freelancing Team Info */}
      <div className="tieup-info">
        <p>
          We have tie-up companies and our own freelancing team providing expert services in:
        </p>
        <ul>
          <li>Website Development</li>
          <li>App Development</li>
          <li>Graphics Design</li>
        </ul>

        <p>
          <strong>Launching Soon:</strong> Cybersecurity domain to strengthen your digital security.
        </p>

        <p>
          Internship opportunities available in:
        </p>
        <ul>
          <li>Web Development</li>
          <li>Java Programming</li>
          <li>Power BI Analytics</li>
          <li>Data Science</li>
          <li>AI / Machine Learning</li>
          <li>Cybersecurity</li>
        </ul>

        <p className="live-assist">
          💬 We also provide <strong>Live Assistance</strong> for all your queries and support.
        </p>
      </div>
    </section>
  );
};

export default Services;
